var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Avatar',{staticClass:"MyAvatar",attrs:{"avatar":_vm.picture}})}
var staticRenderFns = []

export { render, staticRenderFns }